var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinLocation = function SvgPinLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M16 8c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C5.539 18.193 0 12.993 0 8a8 8 0 1 1 16 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  })));
};
export default SvgPinLocation;